import React from "react";
import { Paper } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

type Props = {
    elevation: number,
    BodyComponent: React.ReactNode,
    FooterComponent: React.ReactNode,
    HeaderComponent: React.ReactNode
};

/**
 * Paper Layout Component
 */
export default ({
    elevation = 3,
    BodyComponent,
    FooterComponent,
    HeaderComponent
}: Props) => {
    const classes = makeStyles(styles)();
    return (
        <Paper className={classes.paper} elevation={elevation}>
            {HeaderComponent}
            <div className={classes.content}>{BodyComponent}</div>
            {FooterComponent}
        </Paper>
    );
};
